import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/RequestUserProposalPptx.graphql';
import { Mutation, MutationrequestUserProposalPptxArgs } from '../../__generated__/globalTypes';

export const useRequestUserProposalPptxMutation = (
  options?: MutationHookOptions<Mutation, MutationrequestUserProposalPptxArgs>
) => {
  const [callRequestUserProposalPptx, result] = useMutation<Mutation, MutationrequestUserProposalPptxArgs>(
    MUTATION,
    options
  );

  return { callRequestUserProposalPptx, ...result };
};

export type RequestUserProposalPptxMutationFunction = Mutation['requestUserProposalPptx'];
